import axios from 'axios';
import { DEPARTMENTS_API_URL, API_URL } from 'utils/constants';

const getAxiosInstance = () => {
  let token = localStorage.getItem('token');
  const instance = axios.create({
    baseURL: DEPARTMENTS_API_URL,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
  });

  return instance;
};

export const handleFetchDepartments = async (channelId) => {
  const response = await getAxiosInstance()({
    method: 'get',
    url: '/',
    params: {
      channelId,
    },
  });

  return response.data;
};

export const handleAddDepartment = async (department) => {
  const response = await getAxiosInstance()({
    method: 'post',
    url: '/',
    data: {
      ...department,
    },
  });

  return response.data;
};

export const handleEditDepartment = async (department, teamId) => {
  const { documentId } = department;
  const response = await getAxiosInstance()({
    method: 'put',
    url: documentId,
    data: {
      ...department,
      teamIds: [teamId],
    },
  });
  return response.data;
};

export const handleDeleteDepartment = async (department) => {
  const { documentId } = department;
  const response = await getAxiosInstance()({
    method: 'delete',
    data: {
      ...department,
    },
    url: documentId,
  });

  return response.data;
};

export const handleUploadTeamImage = async (uploadedPhoto, teamId) => {
  const bodyFormData = new FormData();
  bodyFormData.append('avatar', uploadedPhoto);

  const response = await axios({
    method: 'post',
    baseURL: API_URL,
    url: '/v1/Upload/uploadAvatar',
    data: bodyFormData,
    withCredentials: false,
    params: {
      userId: teamId,
    },
  });
  return response.data;
};
